export const suggestions = [
  'Clínica Internacional (Lima)',
  'Clínica de Especialidades Médicas (San Borja)',
  'Clínica Internacional - Centro Médico (San Isidro)',
  'Clínica Javier Prado (San Isidro)',
];

export const clinics = {
  title: '200 clínicas nacionales',
  subtitle: 'Para consultas médicas por S/45',
  limaCallao: [
    {
      name: 'Lima',
      list: [
        'Clínica Maison de Santé (Chorrillos)',
        'Clínica Versalles (Comas)',
        'Clínica Jesús del Norte (Independencia)',
        'Integramedica (Independencia)',
        'Clínica Internacional (Lima)',
        'Clínica Limatambo (San Isidro)',
        'Clínica Montefiori (La Molina)',
        'Clínica Mega Salud Universal (Lima)',
        'Clínica Aviva (Los Olivos)',
        'MEDAVAN (Magdalena del Mar)',
        'Clínica Good Hope (Miraflores)',
        'Centro Médico Suiza Lab (Miraflores)',
        'Clínica Centenario Peruano Japonesa (Pueblo Libre)',
        'Clínica Stella Maris (Pueblo Libre)',
        'Clínica San Bernardo (Pueblo Libre)',
        'Clínica de Especialidades Médicas (San Borja)',
        'Clínica Vesalio (San Borja)',
        'Clínica Javier Prado (San Isidro)',
        'Clínica Internacional - Centro Médico (San Isidro)',
        'Clínica Internacional - Centro Médico (La Molina)',
        'Clínica Médico Medex (San Isidro)',
        'Clínica Limatambo (San Juan de Lurigancho)',
        'Clínica San Juan Bautista (San Juan de Lurigancho)',
        'Clínica Santa Martha de Sur (San Juan de Lurigancho)',
        'Clínica Medica Cayetano Heredia (San Martin de Porres)',
        'Clínica San Gabriel (San Miguel)',
        'Clínica de Día San Judas Tadeo (San Miguel)',
        'Clínica Providencia (San Miguel)',
        'Centro Ambulatorio Clinica internacional (Santiago de Surco)',
        'Clínica Padre Luis Tezza (Santiago de Surco)',
        'Centros Medicos Jockey Salud (Santiago de Surco)',
      ],
    },
    {
      name: 'Callao',
      list: ['Clínica Bellavista', 'Clínica Limatambo Minka Sede I y II'],
    },
  ],
  provinces: [
    {
      name: 'Cañete',
      list: ['Clínica Corazón de Jesús'],
    },
    {
      name: 'Huacho',
      list: ['Clínica San Pedro de Huacho'],
    },
    {
      name: 'Chachapoyas',
      list: ['Centro Médico Virgen del Carmen'],
    },
    {
      name: 'Santa',
      list: [
        'Clínica Juan Pablo II de Chimbote',
        'Clínica Santa María de Chimbote',
        'Clínica Uroginec',
        'Jaime Ulises Cachay Agurto',
        'Clínica Robles',
        'Clínica San Pedro',
        'Tomografías del Norte',
      ],
    },
    {
      name: 'Huaraz',
      list: ['Clínica Ginmedic', 'Hospital de Apoyo Víctor Ramos Guardia', 'Clínica San Pablo - Sede Huaraz'],
    },
    {
      name: 'Huarmey',
      list: ['Policlínico del Dr. Flores Especialidades Médicas'],
    },
    {
      name: 'Abancay',
      list: ['Hospital Guillermo Díaz de la Vega de Abancay'],
    },
    {
      name: 'Andahuaylas',
      list: ['Clínica Peruana de los Andes'],
    },
    {
      name: 'Islay',
      list: ['Centro Médico Divino Niño', 'Rosemarie Tomasa Ocola Murillo'],
    },
    {
      name: 'Arequipa',
      list: ['Policlínico García Bragagnini', 'Clínica San Pablo - Sede Arequipa', 'Clínica Paz Holandesa', 'Clínica Vallesur', 'Remasur - Sede Arequipa'],
    },
    {
      name: 'Huamanga',
      list: ['Clínica Santa María Magdalena', , 'Clínica El Nazareno', , 'Poloclínico del Pilar', , 'Centro de Medicina de Rehabilitación Integral', ,],
    },
    {
      name: 'Cajamarca',
      list: [
        'Clínica Limatambo - Sede Cajamarca',
        'Clínica San Francisco de Asis',
        'Clínica San Lorenzo',
        'MEDES Medicina de Especialidades',
        'Medisalud Group',
        'Policlínico San Antonio',
        'Policlínico Pediátrico del Norte',
        'Centro Médico María Belén',
        'Clínica Los Fresnos',
        'Centro Clínico SANNA - Sede Cajamarca',
        'Tomonorte - Sede Cajamarca',
      ],
    },
    {
      name: 'Jaén',
      list: ['Clínica Jaén', 'Clínica y Botica San Juan'],
    },
    {
      name: 'Cusco',
      list: [
        'Clínica Cima',
        'Clínica San José',
        'Clínica Peruano Suiza',
        'Clínica Macsalud',
        'Clínica SOS Medical Group',
        'Clínica San Juan de Dios - Sede Cusco',
        'Remasur - Sede Cusco',
      ],
    },
    {
      name: 'Espinar',
      list: ['Servicios Médicos Señor de Coyllority', 'Clínica Max Salud'],
    },
    {
      name: 'La Convención',
      list: ['Vanmedic'],
    },
    {
      name: 'Huánuco',
      list: ['Clínica Huánuco', 'Clínica San Gabriel Arcángel'],
    },
    {
      name: 'Leoncio Prado',
      list: ['Clínica Virgen de Guadalupe', ,],
    },
    {
      name: 'Ica',
      list: [
        'Clínica de Ica Dr. Julio Tataje',
        'Clínica Las Condes',
        'Clínica San Vicente de Ica',
        'Clínica Médica San Martín',
        'Clínica Señor de Luren de Ica',
      ],
    },
    {
      name: 'Chincha',
      list: ['FamiSalud - Sede Chincha', 'Clínica de los Vásquez', 'Clínica GAXAY'],
    },
    {
      name: 'Pisco',
      list: ['Clínica Las Américas', 'FamiSalud - Sede Pisco'],
    },
    {
      name: 'Nazca',
      list: ['Policlínico Juan Pablo Elías'],
    },
    {
      name: 'Huancayo',
      list: ['Centro Médico El Milagro', 'FamiSalud - Sede Pisco'],
    },
  ],
};
